import { render, staticRenderFns } from "./FeaturedCreators.vue?vue&type=template&id=2a4648a0&scoped=true"
import script from "./FeaturedCreators.vue?vue&type=script&lang=js"
export * from "./FeaturedCreators.vue?vue&type=script&lang=js"
import style0 from "./FeaturedCreators.vue?vue&type=style&index=0&id=2a4648a0&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2a4648a0",
  null
  
)

export default component.exports